import placeholderImage from './variable-image-placeholder.svg';
import { MEDIA_KINDS, normalizeMediaSource } from './mediaSource';
import { isSlotAwaitingImage, MEDIA_OBJECT_SLOT } from '../utils/imageSlots';

/**
 * L'URL à dessiner pour l'image à plat `urlProp` des props : l'image d'attente
 * dans l'éditeur tant qu'elle attend sa valeur, sinon la sienne.
 */
export function editorImageSrc(props, urlProp, { isEditing }) {
  const slot = { path: '', urlProp, shape: 'flat' };
  return isEditing && isSlotAwaitingImage(props, slot) ? placeholderImage : (props[urlProp] || '');
}

/**
 * Un objet média dont l'image attend sa valeur (`isSlotAwaitingImage`) :
 * l'éditeur montre l'image d'attente de `VariableImage`, pour que le fond ou
 * la slide ne disparaisse pas du canvas. Le site publié n'a rien à afficher et
 * reçoit le média tel quel.
 */
export function withVariablePlaceholder(media, { isEditing }) {
  if (!isEditing || !media || typeof media !== 'object') return media;
  const resolved = normalizeMediaSource(media);
  if (resolved.kind !== MEDIA_KINDS.image) return media;
  if (!isSlotAwaitingImage(resolved, MEDIA_OBJECT_SLOT)) return media;
  return { ...resolved, src: placeholderImage, srcset: '' };
}
